<template>
  <v-app :class="{'inspection-sheet-open': inspectionSheetOpen}">
    <v-navigation-drawer
        v-model="drawer"
        app
        class="hide-for-inspection-sheet"
        clipped
        disable-resize-watcher
    >
      <v-list>
        <v-list-item link exact :to="{name: 'inspections'}">
          <v-list-item-action>
            <v-icon>mdi-home-search</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Inspections</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{name: 'calendar'}">
          <v-list-item-action>
            <v-icon :disabled="false">mdi-calendar-month</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Calendar</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{name: 'message'}">
          <v-list-item-action>
            <v-icon :disabled="false">mdi-email</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Message</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <transition name="fade" mode="out-in" appear>
      <v-app-bar
          v-if="showMenu()"
          app
          class="hide-for-inspection-sheet"
          dense
          elevation="1"
      >
        <v-app-bar-nav-icon class="d-sm-none" @click="drawer = !drawer"></v-app-bar-nav-icon>
        <v-container fluid class="px-0">
          <v-toolbar dense flat class="transparent">
            <v-toolbar-title class="ml-n2">
              <v-img src="/images/acc-logo-rgb.png" contain height="36" width="56"></v-img>
            </v-toolbar-title>
            <v-toolbar-items class="ml-4 d-none d-sm-flex">
              <v-btn depressed to="/">Inspections</v-btn>
              <v-btn depressed to="/calendar">Calendar</v-btn>
              <v-btn depressed to="/message">Message</v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <div class="mr-n4">
              <v-menu offset-y transition="slide-y-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                      <v-btn
                        class="no-outline"
                        icon
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="{ ...on, ...tooltipOn }"
                      >
                        <v-icon color="#89b535" large>
                          mdi-account-circle
                        </v-icon>
                      </v-btn>
                    </template>                    
                    <div class="pa-2">
                      <div><strong>{{ getUser.display_name }}</strong></div>
                      <div>{{ getUser.email_address }}</div>
                    </div>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item :to="{name: 'change-password'}">
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon small>mdi-lock-outline</v-icon> Change Password
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="togglePlatform" dense>
                    <v-list-item-title>
                      <v-icon small>mdi-{{ platform === 'mobile' ? 'monitor' : 'cellphone' }}</v-icon>
                      {{ platform === 'mobile' ? 'Desktop' : 'Mobile' }} View
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="logout" dense>
                    <v-list-item-title>
                      <v-icon small>mdi-logout-variant</v-icon>
                      Log Out
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>
        </v-container>
      </v-app-bar>
    </transition>
    <v-main :class="mainClasses()">
      <transition name="slide-fade" mode="out-in" appear>
        <router-view :key="$route.fullPath + refresh"></router-view>
      </transition>
      <v-snackbar
          :timeout="3000"
          :value="getShowSnackbar"
          :color="getSnackbarColor"
          multi-line
          top
          @input="setShowSnackbar(false)"
      >
        {{ getSnackbarMsg }}
        <template v-slot:action="{ attrs }">
          <v-btn
              dark
              text
              v-bind="attrs"
              @click="setShowSnackbar(false)"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import {unrestrictedRoutes} from "../routes";

export default {
  name: 'App',
  data() {
    return {
      drawer: false,
      refresh: 0,
    }
  },
  computed: {
    ...mapGetters([
      'getShowSnackbar', 'getSnackbarMsg', 'getSnackbarColor',
      'inspectionSheetOpen', 'platform','getUser',
    ]),
  },
  methods: {
    ...mapMutations(['setLoggedOut', 'setShowSnackbar', 'setSnackbarColor', 'togglePlatform']),
    logout() {
      this.$axios.post('/logout')
          .then(() => {
            this.setLoggedOut()
            this.$router.push({name: 'login'})
          })
    },
    showMenu() {
      return ! [...unrestrictedRoutes, 'password-expired'].includes(this.$router.currentRoute.name)
    },
    mainClasses() {
      const routes = [...unrestrictedRoutes, 'password-expired', 'change-password']
      let addClasses = routes.includes(this.$router.currentRoute.name) && ! this.$vuetify.theme.dark
      return {
        'lighten-5': addClasses,
        'grey': addClasses,
      }
    },
  },
  watch: {
    platform() {
      this.refresh++
    },
  }
}
</script>

<style scoped>
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all .2s;
}

.slide-fade-enter, .slide-fade-leave-to
{
  opacity: 0;
  transform: translateY(10px);
}

.no-outline:focus {
  outline: none;
}

.account {
  background-color: #89b535;
}
</style>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:400,500");
.inspection-sheet .v-toolbar__content {
  padding: 0 !important;
}

@media only print {
  .inspection-sheet-open {
    transform: scale(0.70);
    transform-origin: top left;
    color: black !important;
  }
  .inspection-sheet-open .hide-for-inspection-sheet {
    display: none !important;
  }
  .v-dialog__content.v-dialog__content--active {
    position: inherit !important;
  }
  .v-dialog--fullscreen {
    position: absolute !important;
    overflow: visible !important;
    box-shadow: none !important;
  }
  .v-dialog--fullscreen * {
    color: black !important;
  }
  .inspection-sheet-dialog { /* v-card */
    box-shadow: none !important;
  }
  a {
    text-decoration: none !important;
    color: black !important;
  }
  body {
    margin: 0 !important;
  }
  h6 {
    background-color: white !important;
  }
  .v-application h6.grey.lighten-4 {
    background-color: white !important;
    font-weight: bold !important;
  }
  hr {
    border-color: black !important;
    border-width: 2px 0 0 !important;
  }
}
</style>